// TODO: create a "shared" folder for stuff that's used by both the frontend and backend, and a lint rule to prevent importing anything from the proper backend inside the frontend.
// TODO: make the "meat" of a sample deck exist only on the server and not get bundled into the client.

// Sample deck collection with questions and answers for various subjects
export const sampleDecks = {
  "Roman History": [
    {
      question: "Who was the first king of Rome?",
      answer: "Romulus (traditional founder and first king of Rome, 753-716 BCE)",
    },
    {
      question: "When did the Roman Republic begin?",
      answer: "509 BCE, after the overthrow of King Tarquinius Superbus",
    },
    {
      question: "Who was Julius Caesar's heir?",
      answer: "Octavian (Augustus), who became the first Roman Emperor",
    },
    {
      question: "Which emperor built the Colosseum?",
      answer: "Emperor Vespasian began construction, and it was completed under Emperor Titus",
    },
    {
      question: "When did the Western Roman Empire fall?",
      answer: "476 CE, when Romulus Augustus was deposed by Odoacer",
    },
  ],
  "French Revolution": [
    {
      question: "When did the French Revolution begin?",
      answer: "1789, with the Storming of the Bastille on July 14",
    },
    {
      question: "What was the 'Reign of Terror'?",
      answer:
        "A period of violence during the French Revolution (1793-1794) led by Maximilien Robespierre",
    },
    {
      question: "Who was the King of France during the Revolution?",
      answer: "Louis XVI, who was eventually executed by guillotine in 1793",
    },
    {
      question: "What document was inspired by the American Declaration of Independence?",
      answer: "The Declaration of the Rights of Man and of the Citizen (1789)",
    },
  ],
  "World Geography": [
    {
      question: "What is the largest ocean on Earth?",
      answer: "The Pacific Ocean",
    },
    {
      question: "What is the highest mountain in the world?",
      answer: "Mount Everest (8,848.86 meters or 29,031.7 feet)",
    },
    {
      question: "What is the largest desert in the world?",
      answer: "The Antarctic Desert (followed by the Sahara as the largest hot desert)",
    },
    {
      question: "Which country has the most natural lakes?",
      answer: "Canada, with over 2 million lakes",
    },
    {
      question: "What is the longest river in the world?",
      answer: "The Nile River (though some measurements suggest the Amazon is longer)",
    },
    {
      question: "What is the smallest country in the world by land area?",
      answer: "Vatican City (0.49 square kilometers)",
    },
  ],
  "Physics 101": [
    {
      question: "What is Newton's First Law of Motion?",
      answer:
        "An object at rest stays at rest, and an object in motion stays in motion unless acted upon by an external force",
    },
    {
      question: "What is the formula for force?",
      answer: "F = ma (Force equals mass times acceleration)",
    },
    {
      question: "What is the speed of light in a vacuum?",
      answer: "299,792,458 meters per second (approximately 300,000 km/s)",
    },
    {
      question: "What does E=mc² represent?",
      answer:
        "Einstein's mass-energy equivalence formula, where E is energy, m is mass, and c is the speed of light",
    },
    {
      question: "What is the law of conservation of energy?",
      answer: "Energy cannot be created or destroyed, only transformed from one form to another",
    },
  ],
  "Programming Concepts": [
    {
      question: "What is the difference between 'let' and 'const' in JavaScript?",
      answer:
        "'let' allows reassignment while 'const' creates a read-only reference (though object properties can be modified)",
    },
    {
      question: "What is a closure in programming?",
      answer:
        "A function that has access to variables from its outer (enclosing) scope even after the outer function has finished execution",
    },
    {
      question: "What is the time complexity of a binary search?",
      answer: "O(log n)",
    },
    {
      question: "What does REST stand for in API development?",
      answer: "Representational State Transfer",
    },
    {
      question: "What is the difference between an array and a linked list?",
      answer:
        "Arrays store elements in contiguous memory with direct access by index, while linked lists store elements in nodes with pointers to next/previous nodes",
    },
    {
      question: "What is dependency injection?",
      answer:
        "A design pattern where an object receives other objects it depends on, rather than creating them internally",
    },
  ],
  "Art History": [
    {
      question: "Who painted the Mona Lisa?",
      answer: "Leonardo da Vinci",
    },
    {
      question: "What art movement is Salvador Dalí associated with?",
      answer: "Surrealism",
    },
    {
      question: "During which period was the Sistine Chapel ceiling painted?",
      answer: "The High Renaissance (early 16th century)",
    },
    {
      question: "Who painted 'Starry Night'?",
      answer: "Vincent van Gogh",
    },
    {
      question: "What is chiaroscuro?",
      answer:
        "A technique using strong contrasts between light and dark to create depth and volume in painting",
    },
    {
      question: "Which artist is known for cutting off part of his ear?",
      answer: "Vincent van Gogh",
    },
  ],
  "Literature Classics": [
    {
      question: "Who wrote 'Pride and Prejudice'?",
      answer: "Jane Austen",
    },
    {
      question: "What is the name of the main character in 'The Great Gatsby'?",
      answer: "Jay Gatsby (born James Gatz)",
    },
    {
      question: "Who wrote 'War and Peace'?",
      answer: "Leo Tolstoy",
    },
    {
      question: "Which Shakespeare play features the character Hamlet?",
      answer: "Hamlet",
    },
    {
      question: "Who wrote 'One Hundred Years of Solitude'?",
      answer: "Gabriel García Márquez",
    },
  ],
} as const;

// Type for the sample decks
export type SampleDeckNames = keyof typeof sampleDecks;

export const sampleDeckNames = Object.keys(sampleDecks) as SampleDeckNames[];
